import { render } from "./ShadowsContent.vue?vue&type=template&id=6bb3ecfa"
import script from "./ShadowsContent.vue?vue&type=script&lang=js"
export * from "./ShadowsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__